import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'schoolYear'
})
export class SchoolYearPipe implements PipeTransform {
    transform(value : string) {
        if (value.length == 8) return value.substr(0, 4) + ' - ' + value.substr(4);
        if (value.length == 4) return '20' + value.substr(0,2) + ' - ' + '20' + value.substr(2);
        return value;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/schoolyear.pipe.ts